export default __webpack_public_path__ + "static/media/fixes.ecdd2f71.svg";